export default __webpack_public_path__ + "static/white-bg-9ebd2966a41b280f516a0c57c64b827d.jpeg";